import ValidateHealthcardDialog from './ValidateHealthcardDialog.view';

export default ValidateHealthcardDialog;
